import { push } from '@lagunovsky/redux-react-router'
import { all, call, delay, put, takeLatest } from 'redux-saga/effects'

import { setAuthorized } from '../../services/auth/reducer'
import { setUser } from '../../services/user/reducer'

import { callApiAsync } from 'services/api/callAPIAsync'
import { register, setError, setLoading } from './reducer'

import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'

import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import gtmErrorRegistration from 'services/gtm/gtmErrorRegistration'
import gtmSuccessRegistration from 'services/gtm/gtmSuccessRegistration'

function* registerCallSaga(action) {
    const withMemberAccount = action?.payload?.withMemberAccount
    const actionUserPayload = action?.payload?.user

    const user = _.pick(actionUserPayload, ['firstName', 'lastName', 'phone', 'email', 'password'])

    yield put(setLoading(true))
    yield put(setError(null))

    yield put(startLoading())

    const { error } = yield call(callApiAsync, 'register', { ...user })

    if (error) {
        gtmErrorRegistration(withMemberAccount)
        console.error(error)
        yield put(stopLoading())
        yield put(setErrorMessage(error))
        return
    }

    const { data: gdprData, error: gdprError } = yield call(callApiAsync, 'gdprSet', {
        personal: false,
        non_personal: true,
    })

    if (gdprError) {
        gtmErrorRegistration(withMemberAccount)
        console.error(gdprError)
        yield put(stopLoading())
        yield put(setErrorMessage(gdprError))
        return
    }

    yield all([put(setUser(gdprData)), put(setAuthorized(true))])
    gtmSuccessRegistration(withMemberAccount)

    if (!withMemberAccount) {
        yield put(stopLoading())
        yield put(push('/user-profile'))
        yield delay(10)
        yield put(setSuccessMessage('ACCOUNT_CREATED'))
        return
    }

    // CS Club register

    const cinemaid = localStorage.getItem('cinemaid')
    const gender = actionUserPayload.gender
    const birthdate = new Date(actionUserPayload.date).toISOString()

    const city = actionUserPayload.residance
    const zip_code = actionUserPayload.postalCode.toString()
    const mail_sending = actionUserPayload.checkBoxMember

    const { error: loyaltyProgramError } = yield call(callApiAsync, 'loyaltyProgramRegister', {
        cinemaid,
        gender,
        birthdate,
        city,
        zip_code,
        mail_sending,
    })

    yield put(stopLoading())

    if (loyaltyProgramError) {
        console.error(loyaltyProgramError)
        return
    }

    yield put(push('/order-summary'))
    yield delay(10)
    yield put(setSuccessMessage('ACCOUNT_CREATED'))
    yield put(setSuccessMessage('REGISTER_CLUB_SUCCESS'))
}

export default function* registerSaga() {
    yield all([takeLatest(register.type, registerCallSaga)])
}
